module.exports = __webpack_public_path__ + "media/src/assets/images/expand-more-ee84483516a7985d90a15ea055c409cf.svg";